export const getTableInfo = {
  methods: {
    MIXIN_AUX_getLabel(identificacao, seat) {
      if (!identificacao.toLowerCase().includes("mesa")) {
        return identificacao.replace(";", " - ");
      } else if (seat.class === "mesa") {
        return this.MIXIN_AUX_getTableTooltipInfo(identificacao);
      } else if (
        seat.class !== "mesa" &&
        identificacao.toLowerCase().includes("mesa")
      ) {
        return this.MIXIN_AUX_getChairInfoFromTable(identificacao);
      }
    },

    MIXIN_AUX_getTableLineUpLabel(identificacao) {
      let label = "";
      if (!identificacao) return label;
      const hyphenChar = identificacao.split("-").length - 1;

      // Mesa simples - venda por cadeira
      if (identificacao.includes("Mesa") && hyphenChar <= 0)
        label = identificacao.replace("Mesa", "");
      // Mesa simples - venda inteira
      else if (identificacao.includes("MESA") && hyphenChar === 1)
        label = identificacao.split("-")[1];
      // Mesa de Fila - venda por cadeira
      else if (identificacao.includes("Mesa") && hyphenChar === 1)
        label = identificacao.split("-Mesa")[1];
      // Mesa de Fila - venda inteira
      else if (identificacao.includes("MESA") && hyphenChar > 1) {
        const splitId = identificacao.split("-");
        label = splitId[splitId.length - 1];
      }

      return label;
    },

    MIXIN_AUX_getTableTooltipInfo(identificacao) {
      let label = "";
      let hyphensCount = identificacao.split("-").length - 1;

      if (hyphensCount === 0) label = identificacao.replace("Mesa", "Mesa ");
      else if (hyphensCount === 1 && identificacao.includes("MESA"))
        label = `Mesa ${identificacao.split("-")[1]}`;
      else if (hyphensCount === 1 && identificacao.includes("Mesa"))
        label = identificacao.split("-")[1].replace("Mesa", "Mesa ");
      else if (hyphensCount > 1 && identificacao.includes("MESA"))
        label = `Mesa ${identificacao.split("-")[hyphensCount]}`;

      return label || "Mesa";
    },

    MIXIN_AUX_getChairInfoFromTable(identificacao) {
      let label = "";

      if (identificacao.includes("MESA"))
        label = this.MIXIN_AUX_getTableTooltipInfo(identificacao);
      else if (identificacao.includes("Mesa")) {
        const splitId = identificacao.split(";");
        label = `${this.MIXIN_AUX_getTableTooltipInfo(splitId[0])} - Cadeira ${
          splitId[1]
        }`;
      }

      return label || "Mesa";
    },
  },
};
